import { useIntl } from "react-intl";
import { ButtonHTMLAttributes } from "react";
import { isNotEmpty } from "../../utils";

type Props = {
  hero?: boolean;
  fetching?: boolean;
  text?: string;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export default function SubmitButton({
  hero = true,
  fetching = false,
  text,
  disabled,
  className = "",
  ...restProps
}: Readonly<Props>) {
  const intl = useIntl();
  const spinner = fetching ? <i className="btn-spinner" /> : null;
  const displayText = isNotEmpty(text)
    ? text
    : intl.formatMessage({ id: "button.submit" });

  const isDisabled = fetching || disabled;
  const baseClassName = hero ? "btn btn-primary" : "btn";
  const finalClassName = `${baseClassName} ${className}`.trim();

  return (
    <button
      data-testid="submit-button-testid"
      name="submit"
      className={finalClassName}
      disabled={isDisabled}
      type="submit"
      {...restProps}
    >
      {displayText}
      {spinner}
    </button>
  );
}
